import type { FC } from "react";

import { cn } from "@/lib/utils";

interface SortArrowDescProps {
  classes?: string;
}

const SortArrowDesc: FC<SortArrowDescProps> = ({ classes }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      className={cn(classes)}
    >
      <path
        d="M9.49989 0H0.499894C0.401018 2.11122e-05 0.304369 0.0293569 0.222164 0.0842991C0.139959 0.139241 0.0758896 0.217323 0.0380546 0.308673C0.000219561 0.400023 -0.00968207 0.50054 0.00960171 0.597516C0.0288855 0.694493 0.0764889 0.783575 0.146394 0.8535L4.64639 5.3535C4.6928 5.39994 4.74791 5.43679 4.80857 5.46192C4.86922 5.48706 4.93424 5.5 4.99989 5.5C5.06555 5.5 5.13057 5.48706 5.19122 5.46192C5.25188 5.43679 5.30698 5.39994 5.35339 5.3535L9.85339 0.8535C9.9233 0.783575 9.9709 0.694493 9.99018 0.597516C10.0095 0.50054 9.99957 0.400023 9.96173 0.308673C9.9239 0.217323 9.85983 0.139241 9.77762 0.0842991C9.69542 0.0293569 9.59877 2.11122e-05 9.49989 0Z"
        fill="#AFAFAF"
      />
    </svg>
  );
};

export default SortArrowDesc;
